export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14767.0b5ed510.jpg";